import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import usePublicationCompatiblePagination from '@hooks/usePublicationCompatiblePagination'
import usePublicationCompatiblePaginations from '@hooks/usePublicationCompatiblePaginations'

import CompatiblePagination from './CompatiblePagination'

const CompatiblePaginations = (props) => {
  const { publicationId } = props

  const paginationPayload = usePublicationCompatiblePaginations({
    filters: { publication_id: publicationId },
    performHttpRequests: !!publicationId,
  })

  const {
    filteredPublicationCompatiblePaginations,
    hasFilteredPublicationCompatiblePaginations,
    loading,
  } = paginationPayload

  const {
    callbacks: { addCompatiblePagination },
  } = usePublicationCompatiblePagination({ publication_id: publicationId })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Compatible Paginations"
    >
      <DashboardModule.ScrollableSection>
        {filteredPublicationCompatiblePaginations.map(compatiblePagination => (
          <CompatiblePagination
            key={compatiblePagination.id}
            publicationCompatiblePagination={compatiblePagination}
          />
        ))}
      </DashboardModule.ScrollableSection>

      <DashboardModule.Footer
        boxProps={{
          borderTop: hasFilteredPublicationCompatiblePaginations ? '1px solid' : 'none',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => addCompatiblePagination()}
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Pagination
        </Button>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

CompatiblePaginations.propTypes = {
  publicationId: PropTypes.number.isRequired,
}

export default CompatiblePaginations
